import { createSlice } from '@reduxjs/toolkit';
import { ELeadStatus, type ILead } from 'shared/types/features';
import { saveLead } from 'shared/thunks/saveLead';

const initialState: ILead = {
  exists: false,
  status: ELeadStatus.Init,
};

/* istanbul ignore next */
const leadSlice = createSlice({
  initialState,
  name: 'lead',
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(saveLead.pending, state => {
        state.status = ELeadStatus.Init;
      })
      .addCase(saveLead.fulfilled, (state, action) => {
        state.status = action.payload;
        state.exists = true;
      })
      .addCase(saveLead.rejected, (state, action) => {
        state.status = (action.payload as ELeadStatus) || ELeadStatus.Failed;
      });
  },
});

export const { reducer: leadReducer } = leadSlice;
